/* Editorial navigation is progressive enhancement; article and policy content remains readable without JS. */
(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-palmera-prose]').forEach((prose, index) => {
      const nav = prose.closest('.p4-reading-layout')?.querySelector('[data-palmera-toc]');
      if (!nav || nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const title = prose.closest('article')?.querySelector('h1')?.textContent.trim();
      const firstHeading = prose.querySelector('h2');
      if (title && firstHeading?.textContent.trim() === title) firstHeading.remove();
      if (title) prose.querySelectorAll('h2,h3').forEach(heading => {
        const clean = heading.textContent.replace(/^[\p{Extended_Pictographic}\uFE0F⭐★☆\s]+/u, '').replace(/^\d+[.)]\s+/, '');
        if (clean !== heading.textContent) heading.textContent = clean;
      });
      const headings = [...prose.querySelectorAll('h2')];
      if (prose.closest('.p4-article')) prose.querySelectorAll('ul').forEach(list => {
        const items = [...list.children];
        // Short descriptive fragments read as a sentence; actual steps and rich lists retain their semantics.
        if (items.length < 2 || items.length > 5 || items.some(item => item.querySelector('ul,ol,a,img') || item.textContent.trim().length > 90)) return;
        const text = items.map(item => item.textContent.trim().replace(/[.;]$/, '')).join('; ') + '.';
        const previous = list.previousElementSibling;
        if (previous?.tagName === 'P' && previous.textContent.trim().endsWith(':')) {
          previous.append(document.createTextNode(' ' + text));
        } else {
          const paragraph = document.createElement('p');
          paragraph.textContent = text.charAt(0).toLocaleUpperCase('nb-NO') + text.slice(1);
          list.before(paragraph);
        }
        list.remove();
      });
      const interlude = prose.closest('.p4-reading-layout')?.querySelector('[data-article-interlude]');
      if (interlude && headings.length > 2) headings[Math.min(2, headings.length - 1)].before(interlude);
      if (!headings.length) { nav.hidden = true; return; }
      headings.forEach((heading, i) => {
        if (!heading.id) heading.id = `palmera-reading-${index}-${i}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.replace(/^[⭐★☆\s]+/, '');
        nav.append(link);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', e => initialize(e.target));
})();
